'use strict';

angular.module('Directives').directive('ngSortableTable', function() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/old-table.html',
            replace: true,
            scope: {
                table: '=tableData'
            },
            controller: function($scope, RegExpFunc) {

                $scope.templatesPath = '/templates/directives/old-table-templates/';
                $scope.templateDefault = 'text.html';
                $scope.templateActions = 'actions.html';
                $scope.paginationArray = [];
                $scope.countsArray = [
                    5, 10, 15, 20, 25, 30, 50
                ];
                $scope.count = $scope.countsArray[2];
                var lastSelectedCount = $scope.count;
                $scope.selectedArray = [];

                var resetSelected = function() {
                    $scope.selectedArray.map(function(item) {
                        item.selected = false;
                    });
                    $scope.selectedArray = [];
                    $scope.checkedRows = false;
                };

                $scope.resetList = function() {
                    $scope.page = 1;
                    $scope.maxPage = 0;
                    $scope.sorting = {};
                    $scope.resetCurrentParams();
                };

                $scope.resetCurrentParams = function() {
                    $scope.filters = {};
                    resetSelected();
                    $scope.updateList();
                    applySort();
                    correctPageNumber();
                };
                $scope.filtersData = {};



                $scope.updateList = function() {
                    $scope.originalList = [];
                    $scope.table.data.map(function(item) {
                        $scope.originalList.push(item);
                    });
                    $scope.filteredList = $scope.dataArray = $scope.originalList;
                    correctPageNumber();
                };

                var correctPageNumber = function() {
                    lastSelectedCount = Math.max(lastSelectedCount, 1);
                    var orCount = Math.min(lastSelectedCount, $scope.filteredList.length);
                    $scope.maxPage = orCount ? Math.ceil($scope.filteredList.length / orCount) : 1;
                    $scope.page = Math.min(Math.max(1, $scope.page), $scope.maxPage);


                    $scope.paginationArray = [];
                    for (var n = 0; n < ($scope.filteredList.length / orCount) ; n++) {
                        $scope.paginationArray.push(n+1);
                    }

                    var k = $scope.page * orCount;
                    $scope.dataArray = $scope.filteredList.slice(
                        k - orCount,
                        Math.min(k, $scope.filteredList.length));
                };


                $scope.pageUp = function() {
                    $scope.page++;
                    correctPageNumber();
                };
                $scope.pageDown = function() {
                    $scope.page--;
                    correctPageNumber();
                };
                $scope.pageTo = function(n) {
                    $scope.page = n;
                    correctPageNumber();
                };
                $scope.countUp = function() {
                    $scope.count++;
                    lastSelectedCount = $scope.count;
                    correctPageNumber();
                };
                $scope.countDown = function() {
                    $scope.count--;
                    lastSelectedCount = $scope.count;
                    correctPageNumber();
                };
                $scope.countSet = function(k) {
                    lastSelectedCount = k;
                    correctPageNumber();
                };


                $scope.applyFilters = function() {
                    $scope.filteredList = $scope.originalList.filter(function(item) {
                        for (var i in $scope.filters) {
                            var filter = $scope.filters[i];
                            if (filter !== '') {
                                if (angular.element.isArray(item[i])) {
                                    if (item[i].indexOf(filter) == -1) {
                                        return false;
                                    }
                                } else if (item[i] != filter) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    });
                    correctPageNumber();
                };

                $scope.resetFilters = function() {
                    var newFilters = {};
                    for (var item in $scope.filters) {
                        newFilters[item] = '';
                    }
                    $scope.filters = newFilters;
                    $scope.applyFilters();
                };
                var applySort = function(filter) {
                    filter = filter || $scope.sorting['name'];
                    if ($scope.sorting['name']) {
                        $scope.sorting['name'] = filter;
                        $scope.originalList.sort(function(a, b) {
                            return (a[filter] > b[filter] ? 1 : -1) * ($scope.sorting['ASC'] ? -1: 1);
                        });
                    } else {
                        $scope.originalList = [];
                        $scope.table.data.map(function(item) {
                            $scope.originalList.push(item);
                        });
                    }
                };

                $scope.applySort = function(filter) {
                    if (filter != $scope.sorting['name']) {
                        $scope.sorting = {
                            name: filter,
                            ASC: false
                        };
                    } else {
                        if ($scope.sorting['ASC']) {
                            $scope.sorting = {};
                        } else {
                            $scope.sorting['ASC'] = !$scope.sorting['ASC'];
                        }
                    }
                    applySort();
                    $scope.applyFilters();
                };

                $scope.resetList();
                $scope.table = $scope.table || {};
                $scope.table.head = $scope.table.head || [];

                var newHead = [];
                $scope.table.head.map(function(item) {
                    newHead.push(item);
                    if (item.names) {
                        item.names.map(function(subItemName) {
                            newHead.push({
                                name: subItemName,
                                type: item.type,
                                noTitleCell: true,
                                template: item.template
                            });
                        });
                    }
                });

                $scope.table.head = newHead;

                $scope.table.head.map(function(item) {
                    item.sort = item.sort || item.name || false;
                    if (item.type != 'action') {
                        $scope.filters[item.name] = '';
                    }
                });

                $scope.checkedRows = false;

                $scope.checkSelected = function(a) {
                    $scope.checkedRows = !$scope.checkedRows;
                    if ($scope.checkedRows) {
                        $scope.selectedArray = $scope.dataArray;
                        $scope.dataArray.map(function (item) {
                            item.selected = true;
                        });
                    } else {
                        resetSelected();
                    }
                };

                $scope.onCheck = function(item) {
                    item.selected = !(item.selected || false);
                    $scope.selectedArray = $scope.dataArray.filter(function(item) {
                        return item.selected;
                    });
                };

                $scope.$watch('dataArray', function() {
                    $scope.selectedArray.map(function(item) {
                        if ($scope.dataArray.indexOf(item) == -1) {
                            item.selected = false;
                        }
                    });
                    $scope.selectedArray = $scope.dataArray.filter(function(item) {
                        return item.selected;
                    });
                });

                $scope.$watch('selectedArray', function() {
                    var identical = true;
                    for (var k = 0; k < $scope.dataArray.length; k++) {
                        var item = $scope.dataArray[k];
                        if ($scope.selectedArray.indexOf(item) == -1) {
                            identical = false;
                        }
                    }
                    $scope.checkedRows = identical;
                });
                $scope.$watch('count', function() {
                    $scope.countSet($scope.count);
                });

                $scope.createFilters = function() {
                    $scope.filtersData = {};
                    var uniqueArray = {};
                    $scope.table.head.map(function(item) {
                        if (item.name) {
                            $scope.filtersData[item.name] = [];
                        }
                    });
                    $scope.filteredList.map(function(item) {
                        for (var k in item) {
                            if ($scope.filtersData[k]) {
                                uniqueArray[k] = uniqueArray[k] || [''];

                                if (angular.element.isArray(item[k])) {
                                    item[k].map(function(it) {
                                        if (uniqueArray[k].indexOf(it) == -1) {
                                            uniqueArray[k].push(it);
                                        }
                                    });
                                } else {
                                    if (uniqueArray[k].indexOf(item[k]) == -1) {
                                        uniqueArray[k].push(item[k]);
                                    }
                                }

                            }
                        }
                    });
                    for (var z in uniqueArray) {
                        var uA = uniqueArray[z];
                        $scope.filtersData[z] = [];
                        uA.map(function(it) {
                            $scope.filtersData[z].push(it);
                        });
                    }
                };
            },
            link: function($scope) {
                $scope.$watch('table.data', function() {
                    $scope.createFilters();
                    $scope.updateList();
                });
            }
        }
    });


// WEBPACK FOOTER //
// ./js/directives/table-old.js